import Vue from 'vue'
import VueRouter from 'vue-router'
import MisStudentApplicationForm from '../pages/application/MisStudentApplicationForm'
import { getStaffPortalStatus } from '@/helper/util_custom'
import { parentRoute, staffRoute } from '@/router/routerList'
import { showMedicineMenu } from '../helper/util_custom'

Vue.use(VueRouter)
let isJapan = window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API7.toUpperCase())
console.log(isJapan, 'isJapan')
let router = {}

if (getStaffPortalStatus()) {
  router = new VueRouter({
    mode: 'history',
    routes: staffRoute,
  })
} else if (window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API4.toUpperCase())) {
  router = new VueRouter({
    mode: 'history',
    routes: parentRoute,
  })
} else if (window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API6.toUpperCase())) {
  router = new VueRouter({
    mode: 'history',
    routes: [
      {
        path: '/Public/StudentApplicationForm',
        name: 'MisStudentApplicationForm',
        component: MisStudentApplicationForm,
        meta: { bodyClass: 'application-form' },
      },
    ],
  })
}

router.beforeEach((to, from, next) => {
  const isAdminBypass = to.query.admin === 'admin'

  if (to.meta.requiresMedicineMenuAccess && !showMedicineMenu() && !isAdminBypass) {
    next('/')
  } else {
    next()
  }
})

export default router
